export default "__VITE_ASSET__Bsrqf$X3__"